import PropTypes from 'prop-types';

import {
  SHIP_OPTION_GROUP_EGC,
  SHIP_OPTION_GROUP_RETAIL_W_OPTIONS,
  SHIP_OPTION_GROUP_RETAIL_WO_OPTIONS
} from 'constants/shipOptionGroups';

import DesktopOnly from 'components/checkout/caap/DesktopOnly';
import DigitalItem from 'components/checkout/caap/spc/reviewitems/DigitalItem';
import Imb from 'components/checkout/caap/spc/Imb';
import RetailItems from 'components/checkout/caap/spc/reviewitems/RetailItems';
import ShipOptionsSection from 'containers/Checkout/ShipOptionsSection';
import { determineGroupType } from 'helpers/CheckoutUtils';

const ReviewItems = (componentParams, { testId }) => {
  const {
    asinErrors,
    byLineItem = [],
    hasGcQuantityCv,
    hideReviewItems,
    isFetchingCheckoutData,
    onChangeQuantity,
    onToggleShouldDefaultOptionsClick,
    onViewGiftOptionsClick,
    productsByLineItem,
    shouldDefaultOptions,
    showImb,
    excludeShipOptions,
    isOrderReadyToSubmit,
    isInvalidGiftOption,
    eligibleForGiftWrap
  } = componentParams;

  const shipOptionsContainer = excludeShipOptions ? null : <ShipOptionsSection />;

  if (excludeShipOptions && hideReviewItems) {
    return null;
  }

  if (hideReviewItems) {
    return (
      <div>
        { shipOptionsContainer }
      </div>
    );
  }

  const hasMultipleGroups = byLineItem.length > 1;

  return (
    <div>
      {
        <DesktopOnly data-test-id={testId('saveTimeGoToStep')}>
          <Imb
            headerText="Want to save time on your next order and go directly to this step when checking out?"
            onToggleShouldDefaultOptionsClick={onToggleShouldDefaultOptionsClick}
            shouldDefaultOptions={shouldDefaultOptions}
            showImb={showImb} />
        </DesktopOnly>
      }

      {
        byLineItem.map((deliveryGroup, i) => {
          const group = determineGroupType(productsByLineItem, deliveryGroup);
          const groupHeader = hasMultipleGroups ? `Shipment ${i + 1} of ${byLineItem.length}` : 'Shipment Details';
          const showTopDivider = hasMultipleGroups && i !== 0;

          switch (group) {
            case SHIP_OPTION_GROUP_RETAIL_W_OPTIONS:
              return <RetailItems
                eligibleForGiftWrap={eligibleForGiftWrap}
                asinErrors={asinErrors}
                key={`${group}-${i}`}
                groupHeader={groupHeader}
                shipOptionsSection={shipOptionsContainer}
                deliveryGroup={deliveryGroup}
                isFetchingCheckoutData={isFetchingCheckoutData}
                onChangeQuantity={onChangeQuantity}
                onViewGiftOptionsClick={onViewGiftOptionsClick}
                hasShipOptions={true}
                productsByLineItem={productsByLineItem}
                asinErrors={asinErrors}
                excludeShipOptions={excludeShipOptions}
                showTopDivider={showTopDivider}
                isOrderReadyToSubmit={isOrderReadyToSubmit}
                isInvalidGiftOption={isInvalidGiftOption}
              />;
            case SHIP_OPTION_GROUP_RETAIL_WO_OPTIONS:
              return <RetailItems
                eligibleForGiftWrap={eligibleForGiftWrap}
                asinErrors={asinErrors}
                key={group}
                groupHeader={groupHeader}
                deliveryGroup={deliveryGroup}
                isFetchingCheckoutData={isFetchingCheckoutData}
                onChangeQuantity={onChangeQuantity}
                onViewGiftOptionsClick={onViewGiftOptionsClick}
                hasShipOptions={false}
                productsByLineItem={productsByLineItem}
                asinErrors={asinErrors}
                showTopDivider={showTopDivider}
                isOrderReadyToSubmit={isOrderReadyToSubmit}
                isInvalidGiftOption={isInvalidGiftOption}
              />;
            case SHIP_OPTION_GROUP_EGC:
              return <DigitalItem
                key={group}
                deliveryGroup={deliveryGroup}
                excludeShipOptions={excludeShipOptions}
                hasGcQuantityCv={hasGcQuantityCv}
                isFetchingCheckoutData={isFetchingCheckoutData}
                onChangeQuantity={onChangeQuantity}
                productsByLineItem={productsByLineItem}
                groupHeader={groupHeader}
                showTopDivider={showTopDivider}
              />;
            default:
              return null;
          }
        })
      }
    </div>
  );
};

ReviewItems.contextTypes = {
  testId: PropTypes.func
};

export default ReviewItems;
